import React, { useState } from 'react';
import CreateRoom from './CreateRoom';
import HealthSafetyWalkRound from './HealthSafetyWalkRound';

function HPlusS({ db, usersList, currentUserInitials, currentUserDisplayName, currentUserRole }) {
  const [activeTab, setActiveTab] = useState('rooms');

  return (
    <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
      <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', marginBottom: '25px', flexWrap: 'wrap' }}>
        <button onClick={() => setActiveTab('rooms')} className={activeTab === 'rooms' ? 'active-btn' : ''}>
          Create Room
        </button>
        <button onClick={() => setActiveTab('walk-round')} className={activeTab === 'walk-round' ? 'active-btn' : ''}>
          Walk Round Check
        </button>
      </div>

      {activeTab === 'rooms' && <CreateRoom db={db} usersList={usersList} />}
      {activeTab === 'walk-round' && (
        <HealthSafetyWalkRound
          db={db}
          currentUserInitials={currentUserInitials}
          currentUserDisplayName={currentUserDisplayName}
          currentUserRole={currentUserRole}
        />
      )}
    </div>
  );
}

export default HPlusS;